import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { useNoIndex } from "@/lib/seo";
import { Logo } from "@/components/Logo";
import { Input } from "@/components/ui/input";

export default function AdminLogin() {
  useNoIndex("Admin Login | VG Homes");
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) nav("/admin"); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/admin");
    } catch (err) { toast.error(apiError(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-navy-void px-4 grain-overlay">
      <form onSubmit={submit} className="w-full max-w-sm rounded-3xl bg-white p-8 shadow-2xl" data-testid="admin-login-form">
        <div className="flex justify-center mb-6"><Logo /></div>
        <div className="text-center mb-6">
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-navy/5 text-navy mb-3"><Lock className="h-5 w-5" /></div>
          <h1 className="font-display text-xl font-bold text-slate-900">Admin Login</h1>
          <p className="text-sm text-slate-500">VG Homes Content Management</p>
        </div>
        <div className="space-y-3">
          <Input required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" />
          <Input required type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" />
        </div>
        <button type="submit" disabled={loading} data-testid="admin-login-button"
          className="mt-6 w-full rounded-full bg-navy py-3 font-semibold text-white hover:bg-navy-dark transition-colors disabled:opacity-60">
          {loading ? "Signing in..." : "Sign In"}
        </button>
      </form>
    </div>
  );
}
